import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {PopUp} from './PopUp.component';
import {HANDLED_TASK_POPUP_TYPE} from '../../utils/constants';
import {navigateToMyTasks} from '../router/router.function.js';
import { Button, ButtonType } from "components/common/Button.component";

export class HandledTask extends PopUp {

    static propTypes = {
        closeCallback: PropTypes.func, //callback for closing the popup
        handleAction: PropTypes.func, //callback for closing the popup
        translate: PropTypes.func, // to translate texts
        hideClose: PropTypes.bool //do not show the close button
    };

    constructor(props) {
        super(props);
        this.buildContent = this.buildContent.bind(this);

        this.state = {
            comment: '',
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.okButton.focus();
    }

    getTitle() {
        return this.props.translate("popUp.handledTaskWarning.title");
    }

    buildContent() {

        return (
            <div>
                <div className="modal-body">
                    <span>{this.props.translate("popUp.handledTaskWarning.message")}</span>
                </div>

                <div className="modal-footer">
                    <div className="d-flex gap-8 float-start">
                        <Button type={ButtonType.PRIMARY}
                                onClick={this.props.closeCallback}
                                ref={(element) => {
                                    this.okButton = element;
                                }}
                                tabIndex="2"
                                text={this.props.translate("popUp.handledTaskWarning.Close")}
                        />
                        {!this.props.hideClose &&
                            <Button type={ButtonType.SECONDARY}
                                    onClick={navigateToMyTasks}
                                    tabIndex="3"
                                    text={this.props.translate("popUp.handledTaskWarning.goToTasks")}
                            />
                        }
                    </div>
                </div>
            </div>

        );
    }

    getType() {
        if (this.props.popUpType)
            return this.props.popUpType;
        return HANDLED_TASK_POPUP_TYPE;
    }

}

export default HandledTask;
